module.exports = __webpack_public_path__ + "img/mixtape.19626a11.svg";